import { useEffect, useState } from 'react';
import axios from 'axios';
import { getPredKC, checkPredKC } from '../data/predCache';
import _ from 'lodash';
import { hideWithStars } from '../utils/transformTitle';

export default function useKmsApi(
  kcId,
  studentId,
  date,
  pass,
  predModelVersion
) {
  const [graphData, setGraphData] = useState({
    nodes: [],
    relations: [],
    paths: [],
  });
  const [predList, setPredList] = useState([]);
  const direction = pass === 'fail' ? 'backward' : 'forward';
  const depth = 999;
  const [isPredListLoading, setIsPredListLoading] = useState(true);
  const transformKCTitles = (nodes) =>
    _.map(
      nodes,
      ({ properties }) =>
        (properties.title = hideWithStars(properties.title, 8))
    );

  useEffect(() => {
    axios({
      method: 'get',
      url: `https://kms-api-dk.laivdata.com/graph/v2/subgraph/apoc/KC/PREREQUISITEOF/${kcId}?process=traverse&direction=${direction}&depth=${depth}`,
      headers: {
        'X-Laiv-API-Key':
          '2739e304158cee4ff57a258d2cae3216d0ef7dc60a1d040bb4f3a5db28b9',
      },
    })
      .then((result) => {
        transformKCTitles(result.data.data.graph.nodes);

        const data = result.data && result.data.data;
        const graph = data?.graph;
        const paths = data?.paths?.PREREQUISITEOF || [];

        setGraphData({
          nodes: (graph && graph.nodes) || [],
          relations: (graph && graph.rels) || [],
          paths,
        });

        console.log(
          result.data.data.graph.nodes.map((item) => item.properties._uid)
        );

        return checkPredKC(studentId)
          ? getPredKC(studentId)
          : axios({
              method: 'post',
              url: `https://prod-kt-rest-api-txfcgt4xfa-du.a.run.app/v2/predict/kc/laivdata/plunger/${predModelVersion}/${studentId}/${date}`,
              headers: { 'X-Application-id': 'com.laivdata.persona.demo' },
              data: {
                item_ids: result.data.data.graph.nodes.map(
                  (item) => item.properties._uid
                ),
                item_type: 'kc',
              },
            });
      })
      .then((result) => {
        setPredList(result.data.item_list);
        setIsPredListLoading(false);
      });
  }, [kcId, studentId, date, pass, predModelVersion, direction]);

  return [predList, graphData, isPredListLoading];
}
